import {
    serializable,
    DynamicFormControlLayout,
    DynamicInputModel,
    DynamicInputModelConfig,
} from "@ng-dynamic-forms/core";
import { Model_WorkflowComponent, Model_VariableEnvironnement } from 'src/app/app.models';

export class Model_InputGridColumnsBuilderComponent extends Model_WorkflowComponent {
    workflowComponents: Model_WorkflowComponent[];
    variablesEnvironnement: Model_VariableEnvironnement[];
	IS_ROWS_EDITABLE?: boolean;
	IS_ROWS_DELETABLE?: boolean;
}
  
export interface InputGridColumnsBuilderModelConfig extends DynamicInputModelConfig {
    workflowComponents: Model_WorkflowComponent[];
    variablesEnvironnement: Model_VariableEnvironnement[];
	isRowsEditable?: boolean;
	isRowsDeletable?: boolean;
}
  
export class InputGridColumnsBuilderModel extends DynamicInputModel {
	@serializable() readonly type: string = 'input_grid_columns_builder';
    workflowComponents: Model_WorkflowComponent[];
    variablesEnvironnement: Model_VariableEnvironnement[];
	isRowsEditable = false;
	isRowsDeletable = false;
	constructor(config: InputGridColumnsBuilderModelConfig, layout?: DynamicFormControlLayout) {
		super(config, layout);
        this.workflowComponents = config.workflowComponents;
        this.variablesEnvironnement = config.variablesEnvironnement;
		this.isRowsEditable = config.isRowsEditable == true;
		this.isRowsDeletable = config.isRowsDeletable == true;
	}

	public static initModel(_component: Model_InputGridColumnsBuilderComponent) {
		const formModel = new InputGridColumnsBuilderModel({
			id: _component.ID,
			name: _component.ID,
			label: _component.LABEL,
			value: _component.DEFAULT_VALUE,
			required: _component.IS_REQUIRED,
			readOnly: _component.IS_READONLY,
			hidden: _component.IS_VISIBLE !== undefined ? _component.IS_VISIBLE === false : false,
			validators: _component.CUSTOM_VALIDATORS,
			workflowComponents: _component.workflowComponents || [],
			variablesEnvironnement: _component.variablesEnvironnement || [],
            additional: _component,
			isRowsEditable: _component.IS_ROWS_EDITABLE,
			isRowsDeletable: _component.IS_ROWS_DELETABLE,
		});
		return formModel;
	}
}
  